import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {MatDialog} from '@angular/material/dialog';
import * as _moment from 'moment';
import {DoctorService} from '../../../../services/doctor.service';

import {MatSort} from '@angular/material/sort';
@Component({
  selector: 'app-inactive',
  templateUrl: './inactive.component.html',
  styleUrls: ['./inactive.component.css']
})
export class InactiveComponent implements OnInit {

    getAuthState: Observable<any>;
    isAuthenticated: boolean;
    user = null;
    errorMessage = null;
    title = 'Utenti inattivi - analisi'; // titolo generale
    destination = 'general-status';
  
    // servono per la comparsa/scomparsa di componenti nella pagina web
    isDataAvailable = true;
    getDoctorState: Observable<any>;
    @ViewChild(MatSort) sort: MatSort;
    constructor(private router: Router,
      private store: Store<AppState>,
      private doctorService: DoctorService,
      public dialog: MatDialog) {
  this.getAuthState = this.store.select(selectAuthState);
  this.getDoctorState = this.store.select(selectDoctorState);
  }
  
    ngOnInit(): void {
      this.getAuthState.subscribe((state) => {
        this.isAuthenticated = state.isAuthenticated;
        this.user = JSON.parse(localStorage.getItem('user'));
        this.errorMessage = state.errorMessage;
      });
    }
  
  }
  